import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import 'bootstrap'

import '@/assets/styles/scss/layout.scss'
import directives from './directives/index.js'

createApp(App).use(createPinia()).use(router).use(directives).mount('#app')
